import { Component, OnDestroy, OnInit, ViewEncapsulation, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigationVendedor } from 'app/navigation/navigation';
import { LocalStorageService } from 'app/services/local-storage.service';
import { AuthService } from 'app/services/auth/auth.service';
import { Cliente } from 'app/domain/cliente';

import { global } from '../../../utils/global';

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy, AfterViewChecked {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];

    showLogisticaReversiva: boolean;
    showGarantia: boolean;
    showRotacion: boolean;
    showTomarPedido: boolean;
    totalItem: number;
    showRecaudo: boolean;

    showMenuDerecho: boolean;
    

    showCliente: boolean;
    cliente: Cliente;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        public authService: AuthService,
        private cdRef: ChangeDetectorRef,
        private localStorageService: LocalStorageService,
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                'title': 'Online',
                'icon': 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon': 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon': 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon': 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];

        this.languages = [
            {
                id: 'es',
                title: 'Español',
                flag: 'us'
            }
        ];

        this.navigation = navigationVendedor;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, { 'id': this._translateService.currentLang });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    //IMPORTANTE PARA QUE NO GENERE ERROR AL ACTUALIZAR LOS BOTONES DE LOS CARRITOS
    ngAfterViewChecked() {
        let totalItem = this.localStorageService.get(global.SESSION_ITEMS.TOTAL_ITEM);

        if(totalItem != this.totalItem){
            this.totalItem = totalItem;
            this.cdRef.detectChanges();
        }

        let show = this.authService.menuDerecho();
        if (show != this.showMenuDerecho) { // check if it change, tell CD update view
            this.showMenuDerecho = show;

            this.cdRef.detectChanges();
        }

        show = this.authService.logisticaReversiva();
        if (show != this.showLogisticaReversiva) { // check if it change, tell CD update view
            this.showLogisticaReversiva = show;
            this.cdRef.detectChanges();
        }

        show = this.authService.garantia();
        if (show != this.showGarantia) { // check if it change, tell CD update view
            this.showGarantia = show;
            this.cdRef.detectChanges();
        }

        show = this.authService.rotacion();
        if (show != this.showRotacion) { // check if it change, tell CD update view
            this.showRotacion = show;
            this.cdRef.detectChanges();
        }

        
        show = this.authService.tomarPedido();
        if (show != this.showTomarPedido) { // check if it change, tell CD update view
            this.showTomarPedido = show;

            this.cdRef.detectChanges();
        }

        show = this.authService.recaudo();
        if (show != this.showRecaudo) { // check if it change, tell CD update view
            this.showRecaudo = show;
            this.cdRef.detectChanges();
        }

        let cliente = this.localStorageService.get(global.SESSION_ITEMS.CLIENTE);
        show = this.authService.cliente();
        let usuario = this.authService.getUsuario();
        if ((show != this.showCliente || cliente != this.cliente)&&(usuario!=null&& usuario.nombreRol!='AUTORIZADOR'))  { // check if it change, tell CD update view
            this.showCliente = show;
            this.cliente = cliente;
            
            this.cdRef.detectChanges();
        }
    }
}
